module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Regular-2e1e9e15f449b7011987953707f9ead9.woff";